import { FC } from 'react'

import { Icon } from '@ds'

import styles from '../Dialog.module.scss'
import { BracketDialog } from '../assets/BracketDialog'
import { DialogHeader } from './DialogHeader'

type Props = {
  avatar: string
  children: React.ReactNode
  title: React.ReactNode
  roleplay?: string
}

export const DialogItem: FC<Props> = ({
  avatar,
  children,
  title,
  roleplay,
}) => {
  return (
    <section className={styles.dialogItem}>
      {avatar && (
        <DialogHeader avatar={avatar} title={title} roleplay={roleplay} />
      )}
      <div className={styles.dialogItemContent}>
        {avatar && (
          <div className={styles.dialogItemIcon}>
            <Icon name="enterArrow" size="S" />
          </div>
        )}
        <div className={styles.dialogItemContentContainer}>
          {roleplay && (
            <div className={styles.dialogItemRoleplay}>*{roleplay}*</div>
          )}
          <div className={styles.dialogItemContentRoleplayContainer}>
            {!avatar && <BracketDialog className={styles.bracketDialog} />}
            <div className={styles.dialogItemContentBody}>{children}</div>
          </div>
        </div>
      </div>
    </section>
  )
}
